module.exports = __webpack_public_path__ + "static/media/arrow-right-carousel.11f631f9.svg";